const HOST_DEV = `artifact.aikaan.io`;
let backendHost = ``;
let hostToConnect = ``;

const { host, protocol } = window.location;

if (host === `localhost:3000`) {
    hostToConnect = HOST_DEV;
} else {
    hostToConnect = host;
}

// Force backend calls to use HTTP (suitable when UI is served over HTTP)
//backendHost = `http://${hostToConnect}`;
// Use the same protocol the page was loaded with (http: or https:)
backendHost = `${protocol}//${hostToConnect}`;

export const BASE_URL = backendHost;